import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import {
  addNewProvince,
  updateProvince,
} from "../../services/axios/apiManager";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import LoadingSpinner from "../../Components/spinner";
import { provinceValidationSchema } from "./provinceValidations";

const AddEditProvinceModal = ({
  setShowModal,
  showModal,
  selectedProvince,
  setSelectedProvince,
  fetchProvinces,
  countriesList,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleCloseAddEditModal = () => {
    setSelectedProvince({});
    setShowModal(false);
  };

  const handleSubmitForm = async (data) => {
    if (selectedProvince?.id) {
      // // // Edit Province
      const res = await updateProvince({
        id: selectedProvince.id,
        ...data,
      });
      if (res?.data?.success) {
        await fetchProvinces({ currentPage: 1, pageSize: 20 });
        toast.success("Province has been updated.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Update Province:");
      }
    } else {
      // // // Add Province
      const res = await addNewProvince(data);
      if (res?.data?.success) {
        await fetchProvinces({ currentPage: 1, pageSize: 20 });
        toast.success("A new province has been added.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Add Province:");
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>
          {selectedProvince?.id ? "Edit Province" : "Add New Province"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            province_name: selectedProvince?.province_name || "",
            province_code: selectedProvince?.province_code || "",
            country_id: selectedProvince?.country_id || "",
          }}
          validationSchema={provinceValidationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleSubmitForm(values);
            } catch (error) {
              console.log("Error upon Adding/Update Province", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({ handleChange, handleSubmit, values, errors, touched }) => (
            <div className="row">
              {/* province_name */}
              <div className="mb-3">
                <Form.Label className="text-secondary">
                  Province Name
                </Form.Label>
                <Form.Control
                data-testid="p-Name"
                  type="text"
                  placeholder="Enter Province Name"
                  required
                  name="province_name"
                  value={values.province_name}
                  onChange={handleChange("province_name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.province_name && touched?.province_name ? (
                  <span className="text-danger" data-testid="Province-validation-msg">{errors?.province_name}</span>
                ) : null}
              </div>
              {/* province_code */}
              <div className="mb-3">
                <Form.Label className="text-secondary">
                  Province Code
                </Form.Label>
                <Form.Control
                  type="text"
                  data-testid="p-Code"
                  required
                  name="province_code"
                  placeholder="Enter Province Code"
                  value={values.province_code}
                  onChange={handleChange("province_code")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.province_code && touched?.province_code ? (
                  <span className="text-danger" data-testid="Code-validation-msg">{errors?.province_code}</span>
                ) : null}
              </div>
              {/* country_id */}
              <div className="mb-3">
                <Form.Label className="text-secondary">Country</Form.Label>
                <Form.Select
                  type="text"
                  data-testid="p-Country"
                  name="country_id"
                  value={values.country_id}
                  onChange={handleChange("country_id")}
                  className="bg-dark text-light border-light input-placeholder-light"
                >
                  <option value="">Select Country</option>
                  {countriesList?.map((m) => (
                    <option value={m.id}>{m.country_name}</option>
                  ))}
                </Form.Select>
                {errors?.country_id && touched?.country_id ? (
                  <span className="text-danger" data-testid="Country-validation-msg">{errors?.country_id}</span>
                ) : null}
              </div>
              <div className="constainer-fluid" data-testid="loading-spinner">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2" >
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedProvince?.id ? "Update" : "Add Province"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddEditProvinceModal;
